<template>
    <div class="row">
        <div class="col-md-12">
            <h4 class="required">Note</h4>
            <el-input v-model="noteModel"
                      :disabled="disabled"
                      :rows="15"
                      type="textarea"
                      placeholder="Please input"/>
            <p v-if="!$v.note.required" class="text-danger">
                Please input a note
            </p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'OrderNote',
    inject: ['$v'],
    props: {
      disabled: {
        required: false,
        default: false,
        type: Boolean,
      },
      note: {
        type: String,
      },
    },
    computed: {
      noteModel: {
        get() {
          return this.note;
        },
        set(value) {
          this.$emit('update:note', value);
        },
      },
    },
  };
</script>
